/* eslint-disable import/prefer-default-export */

import { CALL_API } from 'redux-api-middleware';
import {
  USER_LOGOUT_REQUEST,
  USER_LOGOUT_SUCCESS,
  USER_LOGOUT_FAILURE
} from '../constants';

export default () => ({
  [CALL_API]: {
    endpoint: '/logout',
    method: 'POST',
    credentials: 'include',
    types: [USER_LOGOUT_REQUEST, USER_LOGOUT_SUCCESS, USER_LOGOUT_FAILURE]
  }
});



// WEBPACK FOOTER //
// ./src/actions/logout.js